import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss']
})
export class RatingComponent implements OnInit {
  @Output() private ratingUpdated = new EventEmitter();
  @Input() ratingArr = [1,2,3,4,5,6,7,8,9,10];
  @Input() rating = 5;
  cloneRating = 0;
  constructor(
    private deviceDetectorService:DeviceDetectorService
  ) {}

  ngOnInit(): void {
    this.cloneRating = this.rating
    this.ratingUpdated.emit(this.rating)
  }
  onClick(rating:number) {
    // console.log(rating)
    this.rating = rating;
    this.cloneRating = rating
    this.ratingUpdated.emit(rating)
    return false;
  }
  onHoverEnter(rating:number) {
    // console.log(rating)
    this.rating = rating;
    // this.ratingUpdated.emit(rating)
    return false;
  }
  onHoverLeave(rating:number) {
    // console.log(rating)
    this.rating = this.cloneRating;
    // this.ratingUpdated.emit(rating)
    return false;
  }
  isMobile(){
    return this.deviceDetectorService.isMobile()
  }
  setClass(index:number) {
    if (this.rating >= index + 1) {
      if(this.rating==10) return 'bg-[#0059ff]' 
      if(this.rating==9) return 'bg-[#0066ff]' 
      if(this.rating==8) return 'bg-[#0073ff]' 
      if(this.rating==7) return 'bg-[#0080ff]' 
      if(this.rating==6) return 'bg-[#3499FF]' 
      if(this.rating==5) return 'bg-[#47A3FF]' 
      if(this.rating==4) return 'bg-[#56AAFF]'
      if(this.rating==3) return 'bg-[#6DB6FF]'
      if(this.rating==2) return 'bg-[#85C2FF]'
      if(this.rating==1) return 'bg-[#A2D1FF]'
      else return '#24AF10'
    } else {
      return 'bg-transparent'
    }
  }
}
